import { Facebook, Instagram, Linkedin } from "lucide-react";
import { Link } from "react-router-dom";
import logo from "@/assets/logo.webp";

const socialLinks = [
  { icon: Facebook, href: "https://www.facebook.com/profile.php?id=61558850813349", label: "Facebook" },
  { icon: Instagram, href: "https://www.instagram.com/solved_media/", label: "Instagram" },
  { icon: Linkedin, href: "https://www.linkedin.com/company/solved-media/", label: "LinkedIn" },
];

export const Footer = () => {
  return (
    <footer className="py-16 border-t border-border/50">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-12 mb-12">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center mb-4">
              <img 
                src={logo} 
                alt="Solved Media" 
                className="h-10 w-auto"
                width={42}
                height={40}
                loading="lazy"
                decoding="async"
              />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-xs">
              I don't hide behind fancy words or overinflated claims. What you see is what you get: someone who's honest, direct, and fully committed.
            </p>
          </div>

          {/* Social */}
          <div className="md:text-right">
            <h4 className="font-semibold text-foreground mb-4">Connect</h4>
            <div className="flex gap-4 mb-6 md:justify-end">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-lg bg-secondary flex items-center justify-center text-muted-foreground hover:text-primary hover:bg-primary/10 transition-colors"
                  aria-label={social.label}
                >
                  <social.icon className="w-5 h-5" />
                </a>
              ))}
            </div>
            <div className="text-sm text-muted-foreground space-y-2">
              <p>Mon - Fri | 09:00AM - 05:00PM</p>
              <a href="tel:+447931676014" className="block hover:text-primary transition-colors">
                +44 7931 676014
              </a>
              <a href="mailto:hello@solvedmedia.co.uk" className="block hover:text-primary transition-colors">
                hello@solvedmedia.co.uk
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-border/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-muted-foreground">
            © {new Date().getFullYear()} Solved Media. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <Link to="/privacy-policy" className="text-sm text-muted-foreground hover:text-primary transition-colors">
              Privacy Policy
            </Link>
            <Link to="/compliance" className="text-sm text-muted-foreground hover:text-primary transition-colors">
              Compliance
            </Link>
          </div>
          <p className="text-sm text-muted-foreground">
            Newark NG24 1EZ, United Kingdom
          </p>
        </div>
      </div>
    </footer>
  );
};
